export const config = {
  SERVER_URL:
    process.env.REACT_APP_NODE_ENV === "development"
      ? "http://localhost:3000"
      : process.env.REACT_APP_SERVER_URL,
  BUCKET_URL:
    process.env.NODE_ENV === "production" ? "prodappdata" : "stagingappdata",
  // Default promo video shown on every seller's store page as ad space.
  // Non-upgraded sellers see this; upgraded (Diamond/Diamond Special/Platinum)
  // sellers can replace it with their own video.
  // TODO: swap this placeholder for the client's branded Moore Exotics promo video.
  DEFAULT_STORE_VIDEO:
    "https://www.youtube.com/watch?v=ScMzIvxBSi4",
};

console.log("SERVER_URL:", config.SERVER_URL);

export default config;
